import { useEffect, useState } from 'react'
import { fetchListingDetail, type ListingDetail } from '../api/store'

export function useStoreDetail(publicId?: string) {
  const [data, setData] = useState<ListingDetail | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!publicId) return
    let cancelled = false
    setLoading(true)
    setError(null)
    fetchListingDetail(publicId)
      .then((d) => { if (!cancelled) setData(d) })
      .catch((e) => { if (!cancelled) setError(e?.message || 'Failed to load listing') })
      .finally(() => { if (!cancelled) setLoading(false) })
    return () => { cancelled = true }
  }, [publicId])

  return { data, loading, error }
}

